import { Grid } from "@mui/material";
import FundItemsList from "../Steps/FundItemsList";

export default function CampaignDetailItemsComponent({ campaign, refetch }: { campaign: any, refetch: any }) {
  return (
    <Grid item xs={12} sx={{ mb:2 }}>
      <FundItemsList fund={campaign} refetchFund={refetch} />
    </Grid>
  )
}